import { Client } from "./baseurl";

export const getResults = async(strToSearch:string) => {
    const response = await Client.get(`/home/item-search?itemTitle=${strToSearch}`);
    return response.data;
}

